// All site entry points use the same current installer. Give every user click
// a fresh request URL so browser/CDN caches cannot reuse a previous release.
export function installRemoteDownloadCacheBypass() {
  const refresh = (event: MouseEvent) => {
    if (!(event.target instanceof Element)) return
    const link = event.target.closest<HTMLAnchorElement>('a[href]')
    if (!link) return
    const url = new URL(link.href, window.location.href)
    if (url.origin !== window.location.origin ||
      url.pathname !== '/remote/SpectraRemote-Windows-x64-Setup.exe') return
    url.searchParams.set('download', `${Date.now()}-${crypto.randomUUID()}`)
    link.href = url.toString()
  }
  document.addEventListener('click', refresh, true)
  document.addEventListener('auxclick', refresh, true)
}
